import React from "react";
import { WithAPICall } from "../utils/apiUtil";
import { Card, IconButton, Tooltip, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import Markdowner from "./Markdowner";
import AudioPlayer from "./AudioPlayer";
import cogoToast from "cogo-toast";
import Iconify from "src/components/iconify";

class SummaryMessageAudio extends React.Component {
  state = {
    audioFileURL: "",
  };
  componentDidMount() {
    this.startPolling();
  }
  componentWillUnmount() {
    this.stopPolling();
  }
  startPolling = () => {
    this.pollInterval = setInterval(this.checkAudioFile, 1000);
  };
  stopPolling = () => {
    clearInterval(this.pollInterval);
  };
  checkAudioFile = async () => {
    if (this.props.genAudioUrl) {
      this.setState({ audioFileURL: this.props.genAudioUrl });
      this.stopPolling();
    } else {
      const audioFileURL = await this.getAudioFile();
      if (audioFileURL) {
        this.setState({ audioFileURL });
        this.stopPolling();
      }
    }
  };
  getAudioFile = async () => {
    try {
      let res = await this.props.apiCallPost("/harley/pollCaseGenAudio", {
        caseId: this.props.caseId,
        messageNanoId: this.props.messageNanoId,
        taskTag: this.props.taskTag,
      });
      if (res && res.genAudioUrl) {
        return res.genAudioUrl;
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };
  renderTitle = () => {
    let audioElem = (
      <Tooltip title="Harley is generating audio for this message in the background. You will be able to play it when it is ready.">
        <IconButton
          onClick={() => {
            cogoToast.info(
              "Harley is generating audio for this message in the background. You will be able to play it when it is ready."
            );
          }}
        >
          <Iconify icon="icon-park-outline:voice-one" />
        </IconButton>
      </Tooltip>
    );
    if (this.state.audioFileURL) {
      audioElem = <AudioPlayer url={this.state.audioFileURL} />;
    }
    return (
      <Stack direction="row" alignItems={"center"} spacing={0.5}>
        <Typography variant="overline">Tamil Summary from Harley</Typography>
        {audioElem}
      </Stack>
    );
  };
  render() {
    return (
      <Card
        sx={{
          p: 2,
          m: 2,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Stack>
          {this.renderTitle()}
          <Markdowner text={this.props.message} />
        </Stack>
      </Card>
    );
  }
}

export default WithAPICall(SummaryMessageAudio);
